// extracted by mini-css-extract-plugin
export default {"content-root":"_1Vskd","contentRoot":"_1Vskd","title":"GdW2Y","message":"_1wk66","image":"_1Oc02"};